import type { ActionTemplateSearchResource } from "@octopusdeploy/octopus-server-client";
import { Environment } from "@octopusdeploy/utilities";

export function hidePrereleaseActionTemplates(actionTemplate: ActionTemplateSearchResource) {
    if (Environment.isInDevelopmentMode()) {
        return true;
    }
    return !actionTemplate.Prerelease;
}
